import { Component, HostListener } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { ParallaxStandaloneDirective } from '@yoozly/ngx-parallax';
import { MapComponent } from './map/map.component';
import { FooterComponent } from './components/footer/footer.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterModule, FooterComponent],
})
export class AppComponent {
  openOverlay() {
    this.showOverlay = true;
  }
  closeOverlay() {
    this.showOverlay = false;
  }
  title = 'cometralci';

  showOverlay = false;

  constructor(public router: Router) {}
}
